import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfilePriceFilterPipe } from '@pipes/profile-price-filter/profile-price-filter';
import { AccountServiceProvider } from '@services/user/account.service';
import { User } from '@models/models';
import { Subscription } from 'rxjs';

@Component({
	selector: 'subscription-monthly-discount',
	template: require('./subscription-monthly-discount.html')
})
export class SubscriptionMonthlyDiscountWebComponent
	implements OnInit, OnDestroy {
	user: User;
	userObservable: Subscription;
	billFull: string;
	coinFull: string;
	bill: string;
	coin: string;
	label: string;

	constructor(
		private accountService: AccountServiceProvider,
		private profilePricePipe: ProfilePriceFilterPipe
	) {}

	ngOnInit() {
		this.getUser();
	}

	ngOnDestroy() {
		this.userObservable.unsubscribe();
	}

	private setAnnualPrice() {
		if (this.user && this.user.subscriptionPrice) {
			const prices = this.user.subscriptionPrice;

			this.billFull = this.profilePricePipe.transform(
				prices.monthlyPrice,
				'bill'
			);
			this.coinFull = this.profilePricePipe.transform(
				prices.monthlyPrice,
				'coin'
			);

			this.bill = this.profilePricePipe.transform(
				prices.monthlyDiscountPrice,
				'bill'
			);
			this.coin = this.profilePricePipe.transform(
				prices.monthlyDiscountPrice,
				'coin'
			);

			this.label = this.profilePricePipe.transform(
				prices.monthlyPrice,
				'label'
			);
		}
	}

	private getUser() {
		this.userObservable = this.accountService.userDataObservable.subscribe(
			user => {
				if (user !== null && typeof user !== 'undefined') {
					this.user = JSON.parse(JSON.stringify(user));
					this.setAnnualPrice();
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/subscription/subscription-elements/subscription-monthly-discount/subscription-monthly-discount.ts